import React from 'react';
import { SignUp } from '@clerk/clerk-react';
import './Home.css';

const SignUpPage = () => {
  return (
    <main>
      <section className="solutions-section">
        <div className="account-creation-container">
          <div className="clerk-signin-wrapper">
            <SignUp
              appearance={{
                layout: {
                  shimmer: false,
                  socialButtonsPlacement: 'bottom',
                  socialButtonsVariant: 'blockButton',
                },
                elements: {
                  card: {
                    backgroundColor: 'rgba(18, 30, 52, 0.98)',
                    border: '1px solid rgba(255,255,255,0.10)',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.5)'
                  },
                  header: { backgroundColor: 'transparent' },
                  headerTitle: { color: '#ffffff' },
                  headerSubtitle: { color: 'rgba(255,255,255,0.7)' },
                  form: { backgroundColor: 'transparent' },
                  socialButtons: { gap: '10px' },
                  socialButtonsBlockButton: {
                    backgroundColor: '#3B82F6',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '8px'
                  },
                  socialButtonsBlockButton__hover: { backgroundColor: '#2563EB' },
                  socialButtonsIconButton: { backgroundColor: '#3B82F6', color: '#fff', border: 'none' },
                  formFieldInput: {
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    border: '1px solid rgba(255,255,255,0.18)',
                    color: '#ffffff'
                  },
                  formButtonPrimary: { backgroundColor: '#3B82F6', color: '#fff', border: 'none' },
                  formButtonPrimary__hover: { backgroundColor: '#2563EB' },
                  footer: { backgroundColor: 'transparent' },
                  footerActionText: { color: 'rgba(255,255,255,0.8)' },
                  footerActionLink: { color: '#60A5FA' },
                  dividerLine: { backgroundColor: 'rgba(255,255,255,0.12)' },
                  dividerText: { color: 'rgba(255,255,255,0.6)' }
                },
                variables: {
                  colorPrimary: '#3B82F6',
                  colorText: '#ffffff',
                  colorBackground: 'rgba(18, 30, 52, 0.98)'
                }
              }}
              routing="path"
              path="/sign-up"
              signInUrl="/"
              // Prefer after* props to avoid step-skipping
              afterSignUpUrl="/dashboard"
              afterSignInUrl="/dashboard"
            />
          </div>
        </div>
      </section>
    </main>
  );
};

export default SignUpPage;

